import { type RefObject, useEffect, useState } from "react";

/**
 * Custom hook to determine if a scrollbar is visible on a given element.
 * @param ref - A React ref object pointing to the element to check for scrollbar visibility.
 */
export function useIsScrollbarVisible(ref: RefObject<HTMLElement | HTMLOListElement | null>): boolean {
	const [isScrollbarVisible, setIsScrollbarVisible] = useState(false);

	useEffect(() => {
		const checkScrollbar = () => {
			if (ref.current) {
				setIsScrollbarVisible(ref.current.scrollHeight > ref.current.clientHeight);
			}
		};

		checkScrollbar();

		const observer = new ResizeObserver(checkScrollbar);
		if (ref.current) {
			observer.observe(ref.current);
		}

		return () => observer.disconnect();
	}, [ref]);

	return isScrollbarVisible;
}
